import { TextMap } from "../../types";

const pt: TextMap = {
  choose_preferred_wallet: "Escolha sua carteira preferida",
  connect_mobile_wallet: "Conectar-se à carteira móvel",
  scan_qrcode_with_wallet: "Ler o código QR com uma carteira compatível com WalletConnect",
  connect: "Conectar",
  // TODO: review following translations
  qrcode: "Código QR",
  mobile: "Móvel",
  copy_to_clipboard: "Copiar",
  copied_to_clipboard: "Copiado!",
  show_more: "Mostrar mais",
  show_less: "Mostrar menos",
};

export default pt;
